import * as Sentry from '@sentry/react';

const LS_KEY = 'elift_diuk';

function captureStorageError(message, err) {
  try {
    Sentry.captureException(err ?? new Error(message), { extra: { message } });
  } catch {
    // Telemetry must never break auth flow.
  }
}

export async function getDeviceToken() {
  try {
    return localStorage.getItem(LS_KEY);
  } catch {
    return null;
  }
}

export async function setDeviceToken(token) {
  if (!token) {
    captureStorageError('No device token provided');
    return false;
  }

  try {
    localStorage.setItem(LS_KEY, token);
    const stored = localStorage.getItem(LS_KEY);
    if (stored !== token) {
      captureStorageError('Device token read-back verification failed');
      return false;
    }
    return true;
  } catch (err) {
    captureStorageError('Failed to set device token in localStorage', err);
    return false;
  }
}

export async function clearDeviceToken() {
  try {
    localStorage.removeItem(LS_KEY);
    return localStorage.getItem(LS_KEY) === null;
  } catch (err) {
    captureStorageError('Failed to clear device token from localStorage', err);
    return false;
  }
}
